import { useSearchParams, Navigate } from 'react-router-dom';
import TofuSurvey from 'packages/signup/components/TofuSurvey';
import SignupForm from 'packages/signup/components/signupForm/index';
import { isOrganicPage, isReferrals } from 'helpers/visitor_page_helper';

// Component that is responsible to get the first route to show to the user.
// This could be based on an experiment or any other url parameter

export default function FirstPageRedirect() {
  const [searchParams] = useSearchParams();
  const background = searchParams.get('background');

  if (background === 'checkout') {
    return <Navigate to={`/account?${searchParams}`} replace />;
  }

  if (isOrganicPage() || isReferrals()) return <SignupForm />;

  return <TofuSurvey />;
}
